import React from 'react';
import { UtpCardSection } from 'common/components';
import { ENTRANCE_DOORS_ELEMENT_BLOCK } from '../../entrance-doors-constants';
import { ENTRANCE_DOORS_UTP_CARD_LIST } from './entrance-doors-utp-section-constants';

type EntranceDoorsUtpSectionProps = {
  onConsultationSignupBtnClick: () => void;
};

export const EntranceDoorsUtpSection = ({ onConsultationSignupBtnClick }: EntranceDoorsUtpSectionProps) => (
  <UtpCardSection
    elementBlock={ENTRANCE_DOORS_ELEMENT_BLOCK}
    elementText="С нами легко и надёжно"
    renderModalContent={({ modal: { content: ModalContent } = {} }, onCloseModal) => (
      ModalContent && <ModalContent
        onConsultationSignupBtnClick={() => {
          onCloseModal();
          onConsultationSignupBtnClick();
        }}
      />
    )}
    title="С&nbsp;нами легко и&nbsp;надёжно"
    utpCardList={ENTRANCE_DOORS_UTP_CARD_LIST}
  />
);
